module.exports = __webpack_public_path__ + "static/media/TD.02914e95.svg";